export default "__VITE_ASSET__DKdN9cx___"